import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { DisclaimerGate } from "@/components/Disclaimer";
import { AuthProvider } from "@/context/Auth";
import { Footer } from "@/components/BuyMeACoffee";
import Home from "@/pages/Home";
import Viva from "@/pages/Viva";
import Results from "@/pages/Results";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import College from "@/pages/College";
import Driving from "@/pages/Driving";
import ExamPrep from "@/pages/ExamPrep";
import MockExam from "@/pages/MockExam";
import Guide from "@/pages/Guide";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/viva/:caseId" element={<Viva />} />
              <Route path="/results/:attemptId" element={<Results />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/college" element={<College />} />
              <Route path="/driving" element={<Driving />} />
              <Route path="/exam-prep" element={<ExamPrep />} />
              <Route path="/mock" element={<MockExam />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </main>
          <Footer />
          <DisclaimerGate />
          <Toaster position="top-center" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
